import loadable from '@loadable/component';
const PageBoxes = loadable(() => import('./Components'));
export default PageBoxes;
